<template>
  <div>
    <p class="tw-mb-4">{{ t("new-customer-added") }}</p>
    <a
      class="tw-ml-auto tw-flex tw-w-fit tw-cursor-pointer tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-secondary-green-800 hover:tw-underline"
      data-test-id="customer-created-toast-link"
      @click="goToCustomer"
    >
      <span class="tw-capitalize">{{ t("go-to-customer") }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="icon icon-tabler icon-tabler-chevron-right"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M9 6l6 6l-6 6" />
      </svg>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useToastStore } from "@/components/TToasts/toast.store";

const props = defineProps<{
  customerUuid: string;
  toastId?: string;
}>();

const { t } = useI18n();
const router = useRouter();

const { closeToast } = useToastStore();

const goToCustomer = () => {
  if (props.toastId) closeToast(props.toastId);
  router.push({
    name: "customer-settings-connections-v2",
    params: { orgUuid: props.customerUuid },
  });
};
</script>
